document.addEventListener("DOMContentLoaded", function () {
    const MAIN_FALLBACK_AGENT_NAME = 'Gaya Home Main';
    const MAIN_FALLBACK_NUMBER = '601120958533';
    const MAIN_FALLBACK_WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=' + MAIN_FALLBACK_NUMBER;
    const FALLBACK_TELEMETRY_URL = 'https://synergytitan-furniture.com/api/whatsapp/fallback-log';
    const META_EVENT_DEDUPLICATION_MINUTES = 30;

    function dedupeElementsById(id) {
        const elements = document.querySelectorAll('#' + id);
        for (let i = 1; i < elements.length; i++) {
            const element = elements[i];
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }

    dedupeElementsById('whatsapp-modal');
    dedupeElementsById('sticky-whatsapp');

    function safeGenerateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }

    function safeSetCookie(name, value, days) {
        if (typeof setCookie === 'function') {
            setCookie(name, value, days);
            return;
        }

        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }

        document.cookie = name + '=' + encodeURIComponent(value || '') + expires + '; path=/; SameSite=None; Secure';
    }

    function safeGetCookie(name) {
        if (typeof getCookie === 'function') {
            return getCookie(name);
        }

        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                try {
                    return decodeURIComponent(c.substring(nameEQ.length, c.length));
                } catch (e) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
        }

        return null;
    }

    function safeGetLocalStorageItem(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function safeReadWhatsAppAttribution() {
        if (typeof readWhatsAppAttribution === 'function') {
            return readWhatsAppAttribution() || {};
        }

        const attributionCookie = window.GAYA_HOME_WA_ATTRIBUTION_COOKIE || 'gh_wa_attribution';
        const values = [
            safeGetCookie(attributionCookie),
            safeGetLocalStorageItem(attributionCookie)
        ];

        for (let i = 0; i < values.length; i++) {
            if (!values[i]) {
                continue;
            }

            try {
                return JSON.parse(values[i]) || {};
            } catch (e) {}
        }

        return {};
    }

    function buildFallbackAgent() {
        return {
            id: 'default',
            name: MAIN_FALLBACK_AGENT_NAME,
            number: MAIN_FALLBACK_NUMBER
        };
    }

    function ensureFallbackHref(linkElement) {
        if (!linkElement) {
            return;
        }

        const currentHref = linkElement.getAttribute('href');
        if (!currentHref || currentHref === '#') {
            linkElement.setAttribute('href', MAIN_FALLBACK_WHATSAPP_URL);
        }
    }

    function normalizeAgent(agent) {
        if (!agent || typeof agent !== 'object') {
            return buildFallbackAgent();
        }

        const number = String(agent.number || '').replace(/[^0-9]/g, '');
        if (!number) {
            return buildFallbackAgent();
        }

        return {
            id: agent.id || 'assigned',
            name: agent.name || MAIN_FALLBACK_AGENT_NAME,
            number: number
        };
    }

    function hasValidAgentNumber(agent) {
        if (!agent || typeof agent !== 'object') {
            return false;
        }

        return String(agent.number || '').replace(/[^0-9]/g, '').length > 0;
    }

    function normalizeNullableString(value) {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        return String(value);
    }

    function getSafeCurrentProductData() {
        if (currentProductData) {
            return currentProductData;
        }

        return {
            productId: productData.id || 'fallback',
            productTitle: productData.title || 'General Inquiry',
            variantId: currentVariant.id || 'fallback',
            variantTitle: currentVariant.title || 'General Inquiry',
            variant: currentVariant.sku || currentVariant.id || 'General Inquiry',
            price: currentVariant.price || productData.price || ''
        };
    }

    async function hashEventScope(value) {
        const encoded = new TextEncoder().encode(value);
        const digest = await window.crypto.subtle.digest('SHA-256', encoded);
        return Array.from(new Uint8Array(digest))
            .map(byte => byte.toString(16).padStart(2, '0'))
            .join('');
    }

    async function generateCookieEventId(scope, buttonType) {
        try {
            if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
                throw new Error('Web Crypto unavailable');
            }

            const keyHash = await hashEventScope(String(scope || '') + '_' + buttonType);
            const cookieKey = 'wa_event_' + keyHash.substring(0, 24);
            let eventId = safeGetCookie(cookieKey);

            if (!eventId) {
                eventId = "event_" + Date.now() + "_" + Math.random().toString(36).substring(2, 15);
                safeSetCookie(cookieKey, eventId, META_EVENT_DEDUPLICATION_MINUTES / (24 * 60));
            }

            return eventId;
        } catch (e) {
            console.warn('Unable to reuse event ID, generating a new one');
            return "event_" + Date.now() + "_" + Math.random().toString(36).substring(2, 15);
        }
    }

    let externalID = safeGetCookie("external_id");
    if (!externalID) {
        externalID = safeGenerateUUID();
        safeSetCookie('external_id', externalID, 30);
    }

    const fbc = safeGetCookie("_fbc");
    const storedAttribution = window.gayaHomeAttribution || safeReadWhatsAppAttribution() || {};
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid') || storedAttribution.fbclid || '';
    const ttclid = urlParams.get('ttclid') || storedAttribution.ttclid || '';

    function getFacebookBrowserId() {
        return safeGetCookie("_fbp") || '';
    }

    function getMetaAttributionParams() {
        return {
            utm_source: urlParams.get('utm_source') || storedAttribution.utm_source || '',
            utm_medium: urlParams.get('utm_medium') || storedAttribution.utm_medium || '',
            campaign_id: urlParams.get('campaign_id') || urlParams.get('utm_id') || storedAttribution.campaign_id || '',
            campaign_name: urlParams.get('campaign_name') || urlParams.get('utm_campaign') || storedAttribution.campaign_name || '',
            adset_id: urlParams.get('adset_id') || storedAttribution.adset_id || '',
            adset_name: urlParams.get('adset_name') || storedAttribution.adset_name || '',
            ad_id: urlParams.get('ad_id') || storedAttribution.ad_id || '',
            ad_name: urlParams.get('ad_name') || urlParams.get('utm_content') || storedAttribution.ad_name || '',
            placement: urlParams.get('placement') || storedAttribution.placement || ''
        };
    }

    function getTrafficSource() {
        return storedAttribution.source || '';
    }

    function getLandingUrl() {
        return storedAttribution.landing_url || window.location.href;
    }

    function getAttributionReferrer() {
        return storedAttribution.referrer || document.referrer || '';
    }

    function getWhatsappSourceValue() {
        const trafficSource = getTrafficSource();
        if (trafficSource === 'TIKTOK' || trafficSource === 'LEMON8') {
            return trafficSource;
        }

        return 'shopify';
    }

    function telemetryReasonFromError(error) {
        if (!error) {
            return 'unknown';
        }

        if (error.telemetryReason) {
            return error.telemetryReason;
        }

        const message = String(error.message || error);
        if (message.indexOf('UI timeout') !== -1) {
            return 'timeout';
        }
        if (message.indexOf('non-JSON') !== -1) {
            return 'non_json_response';
        }
        if (message.indexOf('HTTP ') !== -1) {
            return 'http_error';
        }
        if (message.indexOf('unsuccessful') !== -1) {
            return 'unsuccessful_response';
        }
        if (message.indexOf('invalid agent') !== -1) {
            return 'invalid_agent_number';
        }

        return 'network_error';
    }

    function buildTelemetryPayload(eventName, reason, error, customerNumber, safeProductData, startedAt) {
        return {
            event: eventName || 'fallback_shown',
            reason: reason || 'unknown',
            customer_number: customerNumber || '',
            fallback_number: MAIN_FALLBACK_NUMBER,
            elapsed_ms: startedAt ? String(Date.now() - startedAt) : '',
            page_url: window.location.href,
            product_id: normalizeNullableString(safeProductData.productId),
            product_title: safeProductData.productTitle || '',
            variant_id: normalizeNullableString(safeProductData.variantId),
            variant_title: safeProductData.variantTitle || '',
            source: getWhatsappSourceValue(),
            traffic_source: getTrafficSource(),
            fbclid_present: fbclid ? '1' : '0',
            fbc_present: fbc ? '1' : '0',
            fbp_present: getFacebookBrowserId() ? '1' : '0',
            error_message: error ? String(error.message || error).substring(0, 1000) : ''
        };
    }

    function sendFallbackTelemetry(eventName, reason, error, customerNumber, safeProductData, startedAt) {
        try {
            const params = new URLSearchParams(buildTelemetryPayload(
                eventName,
                reason,
                error,
                customerNumber,
                safeProductData,
                startedAt
            ));

            if (navigator.sendBeacon && navigator.sendBeacon(FALLBACK_TELEMETRY_URL, params)) {
                return;
            }

            fetch(FALLBACK_TELEMETRY_URL, {
                method: 'POST',
                body: params,
                keepalive: true
            }).catch(function() {});
        } catch (telemetryError) {}
    }

    let productData = window.GH_WHATSAPP_PRODUCT_DATA || {
        id: '',
        title: '',
        handle: '',
        vendor: '',
        type: '',
        price: '',
        sku: '',
        variantId: '',
        url: window.location.href,
        variants: []
    };

    let currentVariant = {
        id: productData.variantId,
        sku: productData.sku,
        price: productData.price,
        title: ""
    };

    const selectedVariant = productData.variants.find(v => v.id == productData.variantId);
    if (selectedVariant) {
        currentVariant.title = selectedVariant.title;
        currentVariant.price = selectedVariant.price;
        currentVariant.sku = selectedVariant.sku;
    }

    if (!productData.id) {
        productData = {
            id: 'contact',
            title: 'Contact Inquiry',
            handle: 'contact',
            vendor: '',
            type: 'general',
            price: '0',
            sku: '',
            variantId: 'contact',
            url: window.location.href,
            variants: []
        };
        currentVariant = {
            id: 'contact',
            sku: '',
            price: '0',
            title: 'Contact'
        };
    }

    const baseUrl = "https://synergytitan-furniture.com/shopify-wa-direct";
    const linkId = "38";

    function buildWhatsAppUrl(variant, eventId, useCurrentVariant = true) {
        const params = Object.assign({
            id: linkId,
            link_id: linkId,
            product_id: productData.id,
            product_title: productData.title,
            product_url: window.location.href,
            product_handle: productData.handle,
            product_vendor: productData.vendor,
            product_type: productData.type,
            product_price: useCurrentVariant ? currentVariant.price : productData.price,
            text: productData.title,
            variant: variant || (useCurrentVariant ? currentVariant.sku : productData.sku),
            variant_id: useCurrentVariant ? currentVariant.id : productData.variantId,
            variant_title: useCurrentVariant ? currentVariant.title : '',
            external_id: externalID,
            fbc: fbc || '',
            fbp: getFacebookBrowserId(),
            fbclid: fbclid || '',
            eventId: eventId,
            from: 'shopify',
            source: getWhatsappSourceValue(),
            traffic_source: getTrafficSource(),
            ttclid: ttclid || '',
            landing_url: getLandingUrl(),
            attribution_referrer: getAttributionReferrer(),
            timestamp: Date.now(),
            referrer: document.referrer
        }, getMetaAttributionParams());

        const queryString = Object.keys(params)
            .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
            .map(key => key + '=' + encodeURIComponent(params[key]))
            .join('&');

        return baseUrl + '?' + queryString;
    }

    function trackFacebookEvent(eventId, enquiry, customerPhone = null) {
        if (typeof fbq === "function" && fbc) {
            const customData = {
                content_ids: [enquiry.productId],
                content_type: 'product',
                content_name: enquiry.productTitle,
                content_category: productData.type,
                value: parseFloat(enquiry.price) || 0,
                currency: 'MYR',
                contents: [{
                    id: enquiry.productId,
                    quantity: 1,
                    item_price: parseFloat(enquiry.price) || 0
                }],
                product_variant: enquiry.variantTitle || enquiry.variant,
                variant_id: enquiry.variantId,
                variant_sku: enquiry.variantId === currentVariant.id ? currentVariant.sku : '',
                product_vendor: productData.vendor,
                external_id: externalID
            };

            if (customerPhone && customerPhone.trim() !== '') {
                const formattedPhone = formatPhoneForAdvancedMatching(customerPhone);
                if (formattedPhone) {
                    customData.ph = formattedPhone;
                }
            }

            const eventOptions = { eventID: eventId };
            fbq('track', 'Lead', customData, eventOptions);
        }
    }

    function formatPhoneForAdvancedMatching(phoneNumber) {
        if (!phoneNumber) return null;

        try {
            let cleaned = phoneNumber.replace(/^\\+/, '').replace(/[^0-9]/g, '');
            if (cleaned.startsWith('0')) {
                cleaned = '60' + cleaned.substring(1);
            }

            if (cleaned.length >= 10 && cleaned.length <= 15) {
                return cleaned;
            }

            return null;
        } catch (e) {
            console.error('Error formatting phone for advanced matching:', e);
            return null;
        }
    }

    const modal = document.getElementById('whatsapp-modal');
    const modalClose = document.getElementById('modal-close');
    const whatsappForm = document.getElementById('whatsapp-form');
    const stepPhone = document.getElementById('step-phone');
    const stepAgent = document.getElementById('step-agent');
    const stepLoading = document.getElementById('step-loading');
    const contactAgentBtn = document.getElementById('contact-agent-btn');

    let currentProductData = null;
    let assignedAgent = null;

    if (modalClose) {
        modalClose.onclick = function() {
            modal.style.display = 'none';
            resetModal();
        };
    }

    window.addEventListener('click', function(event) {
        if (event.target == modal) {
            modal.style.display = 'none';
            resetModal();
        }
    });

    function resetModal() {
        if (!stepPhone || !stepAgent || !stepLoading) {
            return;
        }

        stepPhone.style.display = 'block';
        stepAgent.style.display = 'none';
        stepLoading.style.display = 'none';
        assignedAgent = null;

        const phoneInput = document.getElementById('customer-whatsapp');
        if (phoneInput) {
            phoneInput.value = '';
        }
    }

    function formatPhoneNumber(value) {
        let cleaned = value.replace(/^\+/, '').replace(/[^0-9]/g, '');
        if (cleaned.startsWith('0')) {
            cleaned = '60' + cleaned.substring(1);
        }
        return cleaned;
    }

    const customerWhatsappInput = document.getElementById('customer-whatsapp');
    if (customerWhatsappInput) {
        customerWhatsappInput.addEventListener('input', function(e) {
            const cursorPosition = e.target.selectionStart;
            const originalLength = e.target.value.length;
            const formatted = formatPhoneNumber(e.target.value);

            if (formatted !== e.target.value) {
                e.target.value = formatted;
                const lengthDiff = formatted.length - originalLength;
                const newCursorPosition = cursorPosition + lengthDiff;
                e.target.setSelectionRange(newCursorPosition, newCursorPosition);
            }
        });

        customerWhatsappInput.addEventListener('paste', function(e) {
            e.preventDefault();
            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
            const formatted = formatPhoneNumber(pastedText);
            const start = this.selectionStart;
            const end = this.selectionEnd;
            const currentValue = this.value;
            const beforeValue = currentValue.substring(0, start);
            const afterValue = currentValue.substring(end);
            this.value = beforeValue + formatted + afterValue;
            const newCursorPosition = start + formatted.length;
            this.setSelectionRange(newCursorPosition, newCursorPosition);
        });

        customerWhatsappInput.addEventListener('blur', function(e) {
            e.target.value = formatPhoneNumber(e.target.value);
        });
    }

    if (whatsappForm) {
        whatsappForm.addEventListener('submit', function(e) {
            e.preventDefault();

            const phoneInput = document.getElementById('customer-whatsapp');
            if (!phoneInput) {
                window.location.href = MAIN_FALLBACK_WHATSAPP_URL;
                return;
            }

            let customerNumber = phoneInput.value;
            customerNumber = formatPhoneNumber(customerNumber);
            phoneInput.value = customerNumber;

            if (!customerNumber || customerNumber.length < 10) {
                alert('Please enter a valid WhatsApp number with country code (at least 10 digits)');
                return;
            }

            if (!customerNumber.startsWith('60') || customerNumber.length < 11 || customerNumber.length > 12) {
                alert('Please enter a valid Malaysian WhatsApp number (e.g., 60123456789)');
                return;
            }

            stepPhone.style.display = 'none';
            stepLoading.style.display = 'block';
            assignAgent(customerNumber);
        });
    }

    async function assignAgent(customerNumber) {
        const eventId = await generateCookieEventId(customerNumber, 'whatsapp');
        const startedAt = Date.now();
        let assignmentSettled = false;
        let fallbackShown = false;
        let fallbackTelemetrySent = false;
        const safeProductData = getSafeCurrentProductData();

        const requestData = Object.assign({
            customer_number: customerNumber,
            product_id: normalizeNullableString(safeProductData.productId),
            product_title: safeProductData.productTitle,
            variant_id: normalizeNullableString(safeProductData.variantId),
            variant_title: safeProductData.variantTitle,
            product_price: normalizeNullableString(safeProductData.price),
            product_url: window.location.href,
            external_id: externalID,
            fbc: fbc || '',
            fbp: getFacebookBrowserId(),
            fbclid: fbclid || '',
            ttclid: ttclid || '',
            event_id: eventId,
            source: getWhatsappSourceValue(),
            traffic_source: getTrafficSource(),
            landing_url: getLandingUrl(),
            attribution_referrer: getAttributionReferrer()
        }, getMetaAttributionParams());

        const timeoutMs = 5000;

        function showAssignedAgent(agent) {
            assignedAgent = normalizeAgent(agent);

            document.getElementById('agent-name').textContent = assignedAgent.name;
            document.getElementById('agent-number').textContent = assignedAgent.number;

            stepLoading.style.display = 'none';
            stepAgent.style.display = 'block';

            if (fbc) {
                const customerPhone = document.getElementById('customer-whatsapp').value;
                trackFacebookEvent(eventId, safeProductData, customerPhone);
            }
        }

        function showFallbackAgent(error) {
            if (fallbackShown) {
                return;
            }

            fallbackShown = true;
            fallbackTelemetrySent = true;
            console.error('Network/timeout/API error:', error);
            sendFallbackTelemetry(
                'fallback_shown',
                telemetryReasonFromError(error),
                error,
                customerNumber,
                safeProductData,
                startedAt
            );
            showAssignedAgent(buildFallbackAgent());
        }

        setTimeout(() => {
            if (!assignmentSettled) {
                showFallbackAgent(new Error('Assign-agent UI timeout after ' + timeoutMs + 'ms'));
            }
        }, timeoutMs);

        fetch('https://synergytitan-furniture.com/api/whatsapp/assign-agent', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(requestData),
            keepalive: true
        })
        .then(async response => {
            const contentType = response.headers.get('content-type') || '';
            if (!contentType.includes('application/json')) {
                const nonJsonError = new Error('Assign-agent API returned non-JSON response');
                nonJsonError.telemetryReason = 'non_json_response';
                throw nonJsonError;
            }

            const data = await response.json();
            return { response, data };
        })
        .then(({ response, data }) => {
            if (!response.ok) {
                const httpError = new Error(data.message || ('Assign-agent API returned HTTP ' + response.status));
                httpError.telemetryReason = 'http_error';
                throw httpError;
            }

            if (data.success) {
                assignmentSettled = true;
                if (!hasValidAgentNumber(data.agent)) {
                    const invalidAgentError = new Error('Assign-agent API returned invalid agent number');
                    invalidAgentError.telemetryReason = 'invalid_agent_number';
                    showFallbackAgent(invalidAgentError);
                } else if (!fallbackShown) {
                    showAssignedAgent(normalizeAgent(data.agent));
                } else if (fallbackTelemetrySent) {
                    sendFallbackTelemetry(
                        'late_success_after_fallback',
                        'timeout',
                        null,
                        customerNumber,
                        safeProductData,
                        startedAt
                    );
                }
            } else {
                const unsuccessfulError = new Error(data.message || 'Assign-agent API returned unsuccessful response');
                unsuccessfulError.telemetryReason = 'unsuccessful_response';
                throw unsuccessfulError;
            }
        })
        .catch(error => {
            if (!assignmentSettled) {
                assignmentSettled = true;
                if (fallbackShown && fallbackTelemetrySent) {
                    sendFallbackTelemetry(
                        'late_failure_after_fallback',
                        telemetryReasonFromError(error),
                        error,
                        customerNumber,
                        safeProductData,
                        startedAt
                    );
                } else {
                    showFallbackAgent(error);
                }
            }
        });
    }

    if (contactAgentBtn) {
        contactAgentBtn.addEventListener('click', function() {
            try {
                assignedAgent = normalizeAgent(assignedAgent);
                const safeProductData = getSafeCurrentProductData();
                const phoneInput = document.getElementById('customer-whatsapp');
                const customerPhone = phoneInput ? phoneInput.value : '';

                let message = "Hi, nak tanya product ni -> " + safeProductData.productTitle;
                if (safeProductData.variantTitle) {
                    message += "\n -> Set: " + safeProductData.variantTitle;
                }
                if (safeProductData.price) {
                    message += "\nPrice: RM" + safeProductData.price;
                }
                message += "\n\nMy WhatsApp: " + customerPhone;

                const whatsappUrl = "https://api.whatsapp.com/send?phone=" + assignedAgent.number + "&text=" + encodeURIComponent(message);

                if (modal) {
                    modal.style.display = 'none';
                }
                window.location.href = whatsappUrl;
            } catch (error) {
                console.error('Contact agent flow failed, redirecting to main WhatsApp number:', error);
                window.location.href = MAIN_FALLBACK_WHATSAPP_URL;
            }
        });
    }

    const productButton = document.getElementById("whatsapp-link-product");
    ensureFallbackHref(productButton);
    if (productButton) {
        productButton.addEventListener("click", function(e) {
            try {
                e.preventDefault();
                currentProductData = {
                    productId: productData.id,
                    productTitle: productData.title,
                    variantId: currentVariant.id,
                    variantTitle: currentVariant.title || currentVariant.sku || currentVariant.id,
                    variant: currentVariant.sku || currentVariant.id,
                    price: currentVariant.price
                };

                if (!modal) {
                    throw new Error('WhatsApp modal element missing');
                }

                modal.style.display = 'block';
                resetModal();
            } catch (error) {
                console.error('Product WhatsApp flow failed, redirecting to main WhatsApp number:', error);
                window.location.href = MAIN_FALLBACK_WHATSAPP_URL;
            }
        });
    }

    const otherButton = document.getElementById("whatsapp-link-other");
    ensureFallbackHref(otherButton);
    if (otherButton) {
        otherButton.addEventListener("click", function(e) {
            try {
                e.preventDefault();
                currentProductData = {
                    productId: productData.id,
                    productTitle: productData.title,
                    variantId: currentVariant.id,
                    variantTitle: "Combinasi Lain",
                    variant: "Combinasi Lain",
                    price: currentVariant.price
                };

                if (!modal) {
                    throw new Error('WhatsApp modal element missing');
                }

                modal.style.display = 'block';
                resetModal();
            } catch (error) {
                console.error('Other WhatsApp flow failed, redirecting to main WhatsApp number:', error);
                window.location.href = MAIN_FALLBACK_WHATSAPP_URL;
            }
        });
    }

    const stickyButton = document.getElementById("sticky-whatsapp");
    ensureFallbackHref(stickyButton);
    if (stickyButton) {
        stickyButton.addEventListener("click", function(e) {
            try {
                e.preventDefault();
                currentProductData = {
                    productId: productData.id || 'sticky',
                    productTitle: productData.title || 'General Inquiry',
                    variantId: currentVariant.id || 'sticky',
                    variantTitle: 'Sticky Button',
                    variant: 'Sticky Button',
                    price: currentVariant.price || ''
                };

                if (!modal) {
                    throw new Error('WhatsApp modal element missing');
                }

                modal.style.display = 'block';
                resetModal();
            } catch (error) {
                console.error('Sticky WhatsApp flow failed, redirecting to main WhatsApp number:', error);
                window.location.href = MAIN_FALLBACK_WHATSAPP_URL;
            }
        });
    }

    const contactLinks = document.querySelectorAll('#whatsapp-contact-link, .whatsapp-contact-link');
    contactLinks.forEach(function(contactLink) {
        ensureFallbackHref(contactLink);
        contactLink.addEventListener('click', function(e) {
            try {
                e.preventDefault();
                const diningBuilderData = window.GH_DINING_BUILDER_WHATSAPP_DATA;
                currentProductData = diningBuilderData && typeof diningBuilderData === 'object'
                    ? {
                        productId: diningBuilderData.productId || 'dining-set-builder',
                        productTitle: diningBuilderData.productTitle || 'Custom Dining Set',
                        variantId: diningBuilderData.variantId || 'custom-dining-set',
                        variantTitle: diningBuilderData.variantTitle || 'Custom Dining Set',
                        variant: diningBuilderData.variant || 'Custom Dining Set',
                        price: diningBuilderData.price || ''
                    }
                    : {
                        productId: productData.id || 'contact',
                        productTitle: productData.title || 'Contact Inquiry',
                        variantId: currentVariant.id || 'contact',
                        variantTitle: 'Contact Page',
                        variant: 'Contact Page',
                        price: currentVariant.price || ''
                    };

                if (!modal) {
                    throw new Error('WhatsApp modal element missing');
                }

                modal.style.display = 'block';
                resetModal();
            } catch (error) {
                console.error('Contact-page WhatsApp flow failed, redirecting to main WhatsApp number:', error);
                window.location.href = MAIN_FALLBACK_WHATSAPP_URL;
            }
        });
    });

    document.addEventListener('change', function(e) {
        if (e.target.matches('[name="id"], .variant-selector, select[data-variant-id]')) {
            updateCurrentVariant();
        }
    });

    document.addEventListener('variant:change', function(e) {
        if (e.detail && e.detail.variant) {
            updateCurrentVariantFromEvent(e.detail.variant);
        }
    });

    function updateCurrentVariant() {
        const variantIdInput = document.querySelector('[name="id"]');
        if (variantIdInput && variantIdInput.value) {
            const selectedVariantId = variantIdInput.value;
            const variant = productData.variants.find(v => v.id == selectedVariantId);

            if (variant) {
                currentVariant = {
                    id: variant.id,
                    sku: variant.sku,
                    price: variant.price,
                    title: variant.title
                };
            }
        }
    }

    function updateCurrentVariantFromEvent(variant) {
        let price = variant.price;
        if (typeof price === 'number') {
            price = (price / 100).toFixed(2);
        } else if (typeof price !== 'string') {
            price = productData.price;
        }

        currentVariant = {
            id: variant.id.toString(),
            sku: variant.sku || '',
            price: price,
            title: variant.title || ''
        };
    }

    function appendTrackingParams(linkElement) {
        if (!linkElement) return;

        linkElement.addEventListener('click', async function(e) {
            e.preventDefault();

            let linkHref = this.getAttribute('href');
            if (!linkHref) {
                linkHref = 'https://synergytitan-furniture.com/shopify-wa-direct?id=52&text=Hi%2C%20Nak%20info%20info%20product';
            }

            const linkKey = 'link_' + linkHref.substring(0, 50);
            const eventId = await generateCookieEventId(linkKey, 'direct');
            let url = linkHref;

            const separator = url.includes('?') ? '&' : '?';
            url += separator + 'external_id=' + encodeURIComponent(externalID);
            url += '&fbc=' + encodeURIComponent(fbc || '');
            url += '&fbp=' + encodeURIComponent(getFacebookBrowserId());
            url += '&eventId=' + encodeURIComponent(eventId);
            url += '&source=' + encodeURIComponent(getWhatsappSourceValue());
            url += '&traffic_source=' + encodeURIComponent(getTrafficSource());
            url += '&ttclid=' + encodeURIComponent(ttclid || '');
            url += '&landing_url=' + encodeURIComponent(getLandingUrl());
            url += '&attribution_referrer=' + encodeURIComponent(getAttributionReferrer());
            const metaAttribution = getMetaAttributionParams();
            Object.keys(metaAttribution).forEach(function(key) {
                if (metaAttribution[key]) {
                    url += '&' + key + '=' + encodeURIComponent(metaAttribution[key]);
                }
            });

            window.location.href = url;
        });
    }

    const selangorLink = document.getElementById('whatsapp-location-selangor');
    const johorLink = document.getElementById('whatsapp-location-johor');
    appendTrackingParams(selangorLink);
    appendTrackingParams(johorLink);
});
